import React, {forwardRef, useImperativeHandle, useRef} from 'react'
import {Block, Col} from 'jsxstyle'
import {CopilotMessageDto, SenderType} from '../../../services/CopilotMessage/type'
import MessageBubble from './CopilotMessageBubble'
import i18n from '../../../common/i18n'

interface MessageListProps {
  messages: CopilotMessageDto[]
  isLoading: boolean
  isStreaming?: boolean
  streamingContent?: string
}

const MessageList = forwardRef<HTMLDivElement, MessageListProps>(({messages, isLoading, isStreaming = false, streamingContent = ''}, ref) => {
  const localRef = useRef<HTMLDivElement>(null)

  useImperativeHandle(ref, () => localRef.current as HTMLDivElement)

  return (
    <Col props={{ref: localRef}} flex="1" padding="16px" gap="10px" overflow="auto" backgroundColor="#f9faff">
      {messages.length === 0 && !isStreaming ? (
        <Block textAlign="center" color="#666" padding="20px">
          {i18n.t('xk.copilot.chat.empty')}
        </Block>
      ) : (
        <>
          {messages.map((msg) => (
            <MessageBubble key={msg.id} message={msg} />
          ))}

          {isStreaming && (
            <MessageBubble
              message={{
                id: -1,
                createdAt: new Date().toISOString(),
                content: {text: ''},
                senderType: SenderType.BOT,
              }}
              isStreaming={true}
              streamingContent={streamingContent || ''}
            />
          )}
        </>
      )}
      {isLoading && !isStreaming && (
        <Block textAlign="center" color="#666" padding="10px">
          {i18n.t('xk.copilot.chat.loading')}
        </Block>
      )}
    </Col>
  )
})

export default MessageList
